import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-person',
  templateUrl: './person.component.svg',
})
export class MedsafePersonComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
